import useViewport from '../functions/viewport'
import  { useState, useEffect  } from 'react'

import DesktopComponent from './DesktopComponent/DesktopComponent'
import MobileComponent from './MobileComponent/MobileComponent'

const HomePage = () => {
  const { width } = useViewport()

  const [currentTime, setCurrentTime] = useState(Date.now());

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentTime(Date.now());
  }, 1000);

  return () => clearInterval(interval);
}, []);

  return width < 500 ? <MobileComponent currentTime={currentTime} /> : <DesktopComponent currentTime={currentTime} />
}

export default HomePage
